import { Injectable } from "@angular/core";
import { ScrollerUpdateDTO, DefaultService } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class PSScrollerUpdatesCodeService {
    constructor(private psScrollerUpdatesCodeService: DefaultService) {
        this.fetchLast30DaysScrollerData();
    }

    fetchLast30DaysScrollerData() {
        return this.psScrollerUpdatesCodeService.fetchLast30DaysScrollerData().pipe(map(result => result));
    }
    fetchActiveScroller() {
        return this.psScrollerUpdatesCodeService.fetchActiveScroller().pipe(map(result => result));
    }

    psCreateScrollerUpdate(model: ScrollerUpdateDTO) {
        return this.psScrollerUpdatesCodeService.createScrollerUpdate(model).pipe(map(result => result));
    }

    psUpdateScroller(model: ScrollerUpdateDTO) {
        return this.psScrollerUpdatesCodeService.editScrollerUpdate(model).pipe(map(result => result));
    }
}